import React from 'react';

/**
 * Labeled form field — pairs the `.admin-label` caption with its control and an
 * optional hint line, so every input on every screen shares the same anatomy
 * instead of each screen hand-rolling its own label/input/hint stack.
 */
export function Field({
  label,
  htmlFor,
  hint,
  children,
  className = '',
}: {
  label: string;
  htmlFor?: string;
  hint?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={className}>
      <label htmlFor={htmlFor} className="admin-label">
        {label}
      </label>
      {children}
      {hint ? <p className="mt-1.5 text-[11px] leading-relaxed text-mutedDim">{hint}</p> : null}
    </div>
  );
}
